<template>
  <client-only>
    <div v-if="isRendered" class="w-screen h-screen relative">
      <n-b-map class="w-full h-full" ref="bmapRef" :center="center" :zoom="15" :max-zoom="18"
               :dragging="hasLocation" :scrollWheelZoom="hasLocation" :mapClick="false">
        <n-b-map-navigation anchor="BMAP_ANCHOR_BOTTOM_LEFT"/>
        <template v-if="!showRoute">
          <n-b-map-layer ref="mapLayerRef" @onTap="onIconClick"/>
          <n-b-map-marker :position="center" :icon="cruiseIcon" :rotation="rotation"/>
          <!-- <n-b-map-custom-overlay class="w-[68px] h-17 absolute" pane="markerPane" @draw="draw"> -->
          <n-b-map-custom-overlay :key="overlayId" v-if="showPopover" class="w-[68px] h-17 absolute" pane="markerPane" :position="center">
            <!-- <n-b-map-custom-overlay class="w-[68px] h-17 absolute" pane="markerPane" :position="center"> -->
            <el-image class="w-[68px] h-17" src="~/assets/img/cruise-map/icon-ship-active.png"/>
            <div
                class="el-popover el-popper absolute transform !right-0 translate-x-full !top-1/2 -translate-y-1/2 -mr-5"
                x-placement="right">
              <div class="popper__arrow !top-1/2 transform -translate-y-1/2"/>
              <div>
                <el-image class="w-[60px] h-[22px]" fit="contain" :src="cruiseData.base.logo" v-if="cruiseData.base.logo"/>
                <div class="flex items-center mt-2">
                  <el-image class="w-6 h-4 mr-[5px]" fit="contain" :src="cruiseData.base.flag"
                            v-if="cruiseData.base.flag"/>
                  <div class="text-dark text-lg font-semibold">{{ cruiseData.base.name }}</div>
                </div>
                <div class="text-xs text-[#B6B6B6] mt-1 " v-if="cruiseData.base.en_name">{{
                    cruiseData.base.en_name
                  }}
                </div>
                <div class="text-xs font-semibold mt-2 text-[#62676D] whitespace-nowrap"
                     v-if="cruiseData.base.navistatus_label">航行状态：{{ cruiseData.base.navistatus_label }}
                </div>
                <div class="text-xs font-semibold mt-1 text-[#62676D] whitespace-nowrap"
                     v-if="cruiseData.base.update_time">更新时间：{{ cruiseData.base.update_time }}
                </div>
              </div>
              <button class="closeBtn" @click.stop="toggleShowPopover(false)"><i
                  class="el-icon-close"/></button>
            </div>
          </n-b-map-custom-overlay>
        </template>

        <template v-if="hasLocation">
          <n-b-map-reset anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :position="center"
                         :offset="{ width: 20, height: 15 }"/>
          <n-b-map-vgl v-if="showRoute">
            <n-b-map-line-layer ref="lineLayerRef" @reday="onLineLayerReday($event, aisData)"/>
            <n-b-map-label-layer ref="labelLayerRef" @reday="onLabelLayerReday($event, aisData)"/>
          </n-b-map-vgl>
        </template>
      </n-b-map>
      <template v-if="hasLocation">
        <div class="absolute right-[20px] bottom-[90px] shadow">
          <div
              class="flex flex-col items-center justify-center w-[48px] h-[48px] p-1 bg-white first:rounded-t-lg last:rounded-b-lg transition-colors active:bg-gray-50 select-none">
            <el-switch size="mini" :width="30" v-model="showRoute"/>
            <span class="text-xs mt-0.5">轨迹</span>
          </div>
        </div>
        <div v-show="showRoute" class="date_picker absolute left-[10px] top-[10px] flex items-center">
          <el-date-picker v-model="trajectorySearchData" type="daterange" range-separator="至"
                          start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期"
                          class="!w-[280px]">
          </el-date-picker>
        </div>
      </template>
      <div class="map_mask" v-if="!hasLocation"></div>
    </div>
  </client-only>
</template>
<script>
import {computed, defineComponent, nextTick, ref, useFetch, useMeta, useRoute} from "@nuxtjs/composition-api";
import defineAsyncComponent from "~/utils/defineAsyncComponent";
import useRequest from "~/composables/useRequest";
import {getAisCruiseTrajectory, getCruiseDetailById} from "~/services/company";
import {useRouteQuery} from "@/composables/router";
import ICON_SHIP_SELECT from "~/assets/img/cruise-map/icon-ship-selected.png";
import ICON_SHIP from "~/assets/img/cruise-map/icon-ship.png";
import {useToggle} from "@vueuse/shared";
import useCruiseTrajectory from "~/views/company/useCruiseTrajectory";
import {toNumber} from "lodash";
import { useTimeoutFn } from '@vueuse/core'

export default defineComponent({
  auth: false,
  layout: 'default',
  head: {
    title: '航线详情'
  },
  components: {
    CruiseDetailMap: defineAsyncComponent(() => import("@/views/company/CruiseDetailMap.vue"))
  },
  setup() {
    const cruiseId = useRouteQuery('id', '');
    const bmapRef = ref();
    const isRendered = ref(false);
    const {execute, state, isReady} = useRequest(
        () =>
            getCruiseDetailById({
              cruise: cruiseId.value,
            }),
        {
          left_navigation: [],
          base: {
            name: "",
            describe: "", //简述
            introduction: "", //介绍
            label: [], // 标签
            //视频&图片
            images: [],
            attributes: {},
          },
          cabins: [],
          restaurants: [],
          plays: [],
          decks: [],
          photos: [],
          // 当前航次
          voyage: {
            product_tours: [],
          },
          all_voyage: [],
          rank: {},
          news: [],
          services: [],
          company_cruise: [],
          class_cruise: [],
          home_port: [],
        },
        {
          immediate: false,
          resetOnExecute: false
        }
    );

    useMeta(() => {
      const {name} = state.value.base;
      return {
        title: name,
      };
    });

    const {execute: fetchAis, state: aisData} = useRequest(() => getAisCruiseTrajectory({
      id: cruiseId.value
    }), {
      data: {
        cruiseData: []
      }
    }, {immediate: true});


    const center = computed(() => ({
      lng: state.value.base.longitude,
      lat: state.value.base.latitude
    }));

    useFetch(async () => {
      await execute(0);
      isRendered.value = true;
    });

    const overlayId = ref(Date.now());
    const TIMEOUT = 10 * 60 * 1000;
    const {start} = useTimeoutFn(async () => {
      await execute(0);
      start();
      overlayId.value = Date.now();
    }, TIMEOUT)

    const {
      showRoute,
      trajectorySearchData,
      lineLayerRef,
      labelLayerRef,
      onLineLayerReday,
      onLabelLayerReday
    } = useCruiseTrajectory(bmapRef, aisData, cruiseId);

    const hasLocation = computed(() => !!(state.value.base.latitude && state.value.base.longitude))


    const cruiseIcon = computed(() => {
      return {
        url: showPopover.value ? ICON_SHIP_SELECT : ICON_SHIP,
        size: {width: 40, height: 80}
      }
    })

    const [showPopover, toggleShowPopover] = useToggle(true)


    const onIconClick = async () => {
      nextTick(() => {
        if (showPopover.value) {
          return
        }
        console.log('onIconClick')
        toggleShowPopover(true)
      })
    }
    return {
      isRendered,
      overlayId,
      isReady,

      bmapRef,

      cruiseId,
      cruiseData: state,

      aisData,

      rotation: computed(() => toNumber(state.value.base.cog) || 0),

      center,

      hasLocation,
      cruiseIcon,

      showRoute, trajectorySearchData, lineLayerRef, labelLayerRef, onLineLayerReday, onLabelLayerReday,

      showPopover,
      toggleShowPopover,

      onIconClick
    }
  }
})
</script>
<style lang="scss" scoped>
.date_picker ::v-deep .el-range-separator {
  width: auto;
}
.map_mask {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: rgba(0, 0, 0, 0.45);
}
.map_mask::before {
  content: "暂无定位信息";
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  font-size: 15px;
  line-height: 1;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  pointer-events: none;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.closeBtn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 9999px;
  height: 1.75rem;
  position: absolute;
  right: -1rem;
  top: -1rem;
  width: 1.75rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
}
.closeBtn:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
</style>
